import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import { Button } from '@navi/web-ui/lib/primitives';
import { ITableActions } from '../../types';
import { copyAnomalyUrl } from '../../pages/OpenAnomaly/TableContent';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';

const Actions = (props: ITableActions) => {
  const { viewAnomalyHandler, info } = props;

  const viewDetailsHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    viewAnomalyHandler(info);
  };

  const copyLinkHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e?.stopPropagation();
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_ANOMALY_TRACKER_ANOMALY_COPY_LINK_CLICKED, {
      anomalyId: info?.anomalyId
    });
    copyAnomalyUrl(e, info?.anomalyReferenceId?.toString());
  };

  return (
    <div className="flex gap-2">
      <Button variant="text" onClick={viewDetailsHandler}>
        View
      </Button>
      <div className="w-[1px] bg-[var(--navi-color-navigation-blue-c2)]" />
      <Button
        variant="text"
        onClick={copyLinkHandler}
        endAdornment={<CopyToClipboardIcon width={20} height={20} />}
      >
        Link
      </Button>
    </div>
  );
};

export default Actions;
